__turbopack_context__.v({
  "root": "NotValidEuEmptyState-module-scss-module__0J_fzG__root",
});
